import { FC, useId, useState } from 'react';
import { Input } from 'components/common/Input';
import { useTranslation } from 'react-i18next';

import s from './PaymentBankAccount.module.css';

export const PaymentBankAccount: FC = () => {
  const { t } = useTranslation();
  const securityNoteId = useId();

  const [accountHolderName, setAccountHolderName] = useState('');
  const [iban, setIban] = useState('');
  const [bankCountry, setBankCountry] = useState('');
  const [bankName, setBankName] = useState('');

  return (
    <div className={s['payment-bank-account']}>
      <fieldset
        className={s['payment-bank-account__panel']}
        aria-describedby={securityNoteId}
      >
        <legend className={s['payment-bank-account__legend']}>
          {t('payment.bankAccount')}
        </legend>

        <div className={s['payment-bank-account__fields']}>
          <Input
            className={s['payment-bank-account__input']}
            type='text'
            value={accountHolderName}
            onChange={(e) => setAccountHolderName(e.target.value)}
            placeholder={t('payment.accountHolderName')}
            aria-label={t('payment.accountHolderName')}
            autoComplete='name'
          />

          <Input
            className={s['payment-bank-account__input']}
            type='number'
            value={iban}
            onChange={(e) => setIban(e.target.value)}
            placeholder={t('payment.accountNumberIban')}
            aria-label={t('payment.accountNumberIban')}
            autoComplete='off'
          />

          <Input
            className={s['payment-bank-account__input']}
            type='text'
            value={bankCountry}
            onChange={(e) => setBankCountry(e.target.value)}
            placeholder={t('payment.bankCountry')}
            aria-label={t('payment.bankCountry')}
            autoComplete='country-name'
          />

          <Input
            className={s['payment-bank-account__input']}
            type='text'
            value={bankName}
            onChange={(e) => setBankName(e.target.value)}
            placeholder={t('payment.bankName')}
            aria-label={t('payment.bankName')}
            autoComplete='organization'
          />

          <p className={s['payment-bank-account__note']} id={securityNoteId}>
            {t('payment.securityNote')}
          </p>
        </div>
      </fieldset>
    </div>
  );
};
